import * as React from 'react';

/**
 * Heading sizes for Reference pages.
 *
 * Written as literal Tailwind class strings so the content scanner
 * (tailwind.config.js -> content: './src/**\/*.js') emits the CSS.
 * Do not build these strings dynamically.
 *
 * text-5xl = 48px, text-4xl = 36px, text-2xl = 24px.
 * No responsive prefix: the same size applies at every breakpoint.
 */
export const REFERENCE_HEADING_SCALE = {
  h1: 'text-5xl',
  h2: 'text-4xl',
  h3: 'text-2xl',
  h4: 'text-2xl',
  h5: 'text-2xl',
  h6: 'text-2xl',
  p: 'text-2xl',
};

/** Applied to every FancyTitle rendered on Reference pages. */
export const REFERENCE_HEADING_MARGIN_BOTTOM = 'mb-8';

const HeadingScaleContext = React.createContext(null);

export function HeadingScaleProvider({ scale, marginBottom, children }) {
  return (
    <HeadingScaleContext.Provider value={{ scale, marginBottom }}>
      {children}
    </HeadingScaleContext.Provider>
  );
}

/** Returns null outside a provider, which keeps legacy behaviour intact. */
export function useHeadingScale() {
  return React.useContext(HeadingScaleContext);
}
